import {
  IEntryRecordParametersTranslator,
  IEntryRecordLabels,
  IGenericRequestParametersTranslator,
  IModificationRecordLabels,
  IModifiedRecordParametersTranslator,
  INamedEntityLabels,
  IPaginationParametersTranslator,
  IPermissionedEntityLabels,
  ISoftDeletableFilterParametersTranslator,
  ISoftDeletableLabels,
  PropertyTranslator,
  IUniqueEntityLabels,
  IUniqueEntityParametersTranslator,
  ILockableEntityLabels,
  ILockableEntityParametersTranslator,
  ISignableEntityLabels,
  ISignableEntityParametersTranslator,
} from "../../api/GenericTranslator";
import {
  IEntryRecord,
  ICreatedRecordParameters,
  IGenericRequestParameters,
  IModelWithIntId,
  IModificationRecord,
  IModifiedRecordParameters,
  INamedEntity,
  IPaginationParameters,
  IPermissionedEntity,
  IVersionedEntity,
  IVersionedEntityParameters,
  IEntityMinimalModel,
  ISoftDeletableFilterParameters,
  ISoftDeletable,
  EntityConstants,
  EntryRecordOrderBy,
  ModificationRecordOrderBy,
  GenericEntityOrderBy,
  VersionedOrderBy,
  IUniqueEntity,
  IUniqueEntityParameters,
  ILockableEntity,
  ILockableEntityParameters,
  ISignableEntity,
  ISignableEntityParameters,
  NamedEntityOrderBy,
} from "../../api/GenericTypes";
import { LabNotebookMinimalModel } from "./LabNotebook";

export const labNotebookExperimentsConstants: EntityConstants<LabNotebookExperiment, LabNotebookExperimentFilters> = {
  resource: "lab_notebook_experiments",
  frontendIndexRoute: "lab_notebook_experiments",
  entitySingular: "notebook experiment",
  entityPlural: "notebook experiments",
  icon: "file-text",
};

export const labNotebookExperimentFieldLabels: PropertyTranslator<LabNotebookExperiment> = {
  ...INamedEntityLabels,
  ...IPermissionedEntityLabels,
  ...IEntryRecordLabels,
  ...IModificationRecordLabels,
  ...ISoftDeletableLabels,
  ...IUniqueEntityLabels,
  ...ILockableEntityLabels,
  ...ISignableEntityLabels,
  id: "Notebook experiment ID",
  version: "Version",
  description: "Description",
  status: "Status",
  labNotebook: "Notebook",
};

export interface LabNotebookExperiment
  extends IModelWithIntId,
    INamedEntity,
    IEntryRecord,
    IModificationRecord,
    IPermissionedEntity,
    ISoftDeletable,
    IVersionedEntity,
    IUniqueEntity,
    ILockableEntity,
    ISignableEntity {
  labNotebook: LabNotebookMinimalModel;
  name: string;
  status: LabNotebookExperimentStatus;
  description: string;
}
export interface LabNotebookExperimentSuggestions extends IEntityMinimalModel<LabNotebookExperiment["id"]> {}

export interface LabNotebookExperimentMinimalModel extends IEntityMinimalModel {
  status: LabNotebookExperimentStatus;
}

export type LabNotebookExperimentStatus = "RUNNING" | "PAUSED" | "COMPLETED" | "FAILED" | "ABORTED";
export const LabNotebookExperimentStatusList = ["RUNNING", "PAUSED", "COMPLETED", "FAILED", "ABORTED"];

export interface LabNotebookExperimentVersion extends LabNotebookExperiment, IVersionedEntity {}

export type LabNotebookExperimentWriteModel = Omit<
  LabNotebookExperiment,
  "id" | "enteredBy" | "enteredOn" | "modifiedBy" | "modifiedOn" | "isDeleted" | "version"
>;

export interface LabNotebookExperimentFilters
  extends IGenericRequestParameters<LabNotebookExperiment, LabNotebookExperimentSortingOptions>,
    IPaginationParameters,
    ICreatedRecordParameters,
    IModifiedRecordParameters,
    ISoftDeletableFilterParameters,
    IUniqueEntityParameters,
    ILockableEntityParameters,
    ISignableEntityParameters {
  labNotebookIds?: number[] | null;
  status?: LabNotebookExperimentStatus[] | null;
  labNotebookProjectIds?: number[] | null;
}

export interface LabNotebookExperimentVersionFilter extends LabNotebookExperimentFilters, IVersionedEntityParameters {}

export const LabNotebookExperimentSortingOptionsConsts = [
  ...GenericEntityOrderBy,
  ...NamedEntityOrderBy,
  ...EntryRecordOrderBy,
  ...ModificationRecordOrderBy,
  ...VersionedOrderBy,
  "LAB_NOTEBOOK_ID",
  "LAB_NOTEBOOK_NAME",
  "STATUS",
] as const;
export type LabNotebookExperimentSortingOptions = (typeof LabNotebookExperimentSortingOptionsConsts)[number];

export const LabNotebookExperimentFiltersTranslator: PropertyTranslator<LabNotebookExperimentFilters> = {
  ...IPaginationParametersTranslator,
  ...IGenericRequestParametersTranslator,
  ...IEntryRecordParametersTranslator,
  ...IModifiedRecordParametersTranslator,
  ...ISoftDeletableFilterParametersTranslator,
  ...IUniqueEntityParametersTranslator,
  ...ILockableEntityParametersTranslator,
  ...ISignableEntityParametersTranslator,
  status: "Status",
  labNotebookIds: "Notebook IDs",
  labNotebookProjectIds: "Notebook Project IDs",
};
